module.exports = __webpack_public_path__ + "static/wand_of_wonder-mtg_clb-663a260d529ef555646f7109cd34baea.jpg";